import HoldingSettlementPage from './HoldingSettlementPage';

const HoldingSettlements = () => (
    <HoldingSettlementPage
        title="Holding Settlements"
        breadcrumbTitle="Holding Settlements"
    />
);

export default HoldingSettlements;
